import { render, staticRenderFns } from "./Accordion.vue?vue&type=template&id=a2597efe&scoped=true&"
import script from "./Accordion.vue?vue&type=script&lang=js&"
export * from "./Accordion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2597efe",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a2597efe')) {
      api.createRecord('a2597efe', component.options)
    } else {
      api.reload('a2597efe', component.options)
    }
    module.hot.accept("./Accordion.vue?vue&type=template&id=a2597efe&scoped=true&", function () {
      api.rerender('a2597efe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2m5Qwtv0T70tC/JS/comp/Accordion.vue"
export default component.exports